import * as Icons from "framework7-icons/react/framework7-icons-react.cjs";

export type Framework7IconName = keyof typeof Icons;

export const Framework7Icons = Object.keys(Icons).reduce(
  (acc, key) => {
    acc[key as Framework7IconName] = key;
    return acc;
  },
  {} as Record<Framework7IconName, Framework7IconName>,
);

export interface Framework7Icon {
  name: Framework7IconName;
  size?: number;
  color?: string;
}
